import { Notification } from 'element-ui'
const DmNotification = Notification
export default DmNotification

